import { Box, Typography } from "@mui/material";

import type { ConnectionLabel } from "./connectionLabel";

/** A login in an open list: what it is, then its id and the rest, muted. */
export function ConnectionOptionText({ label }: { label: ConnectionLabel }) {
  return (
    <Box sx={{ minWidth: 0 }} title={label.full}>
      <Typography variant="body2" noWrap>
        {label.primary}
      </Typography>
      {label.secondary ? (
        <Typography
          variant="caption"
          color="text.secondary"
          noWrap
          component="div"
        >
          {label.secondary}
        </Typography>
      ) : null}
    </Box>
  );
}

/** A chosen login in a closed select: one line, cut with "...", whole on hover. */
export function ConnectionValueText({ label }: { label: ConnectionLabel }) {
  return (
    <Typography variant="body2" noWrap title={label.full} sx={{ minWidth: 0 }}>
      {label.short}
    </Typography>
  );
}
